import { render, staticRenderFns } from "./SnowDataTableHeader.vue?vue&type=template&id=1ab58c8e&scoped=true&"
import script from "./SnowDataTableHeader.vue?vue&type=script&lang=js&"
export * from "./SnowDataTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./SnowDataTableHeader.vue?vue&type=style&index=0&id=1ab58c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab58c8e",
  null
  
)

export default component.exports